import { bansSlice } from '../slices';

export const { clearBans, setBanLoading } = bansSlice.actions;
